import React from 'react';
import {
  AiFillLinkedin,
  AiFillTwitterCircle,
  AiOutlineGithub,
  AiOutlineInstagram,
} from 'react-icons/ai';
import { FaFacebook } from 'react-icons/fa';

const Social = () => {
  return (
    <div className=" grid gap-7 -ml-0 md:-ml-9 ">
      <a
        href="https://github.com/phrubel"
        className="social-icon"
        target="_blank"
        rel="noreferrer"
      >
        <AiOutlineGithub />
      </a>

      <a
        href="https://www.linkedin.com/in/parvezhasanrubel/"
        className="social-icon"
        target="_blank"
        rel="noreferrer"
      >
        <AiFillLinkedin />
      </a>
      <a
        href="https://www.facebook.com/parvezhasanrubel42/"
        className="social-icon"
        target="_blank"
        rel="noreferrer"
      >
        <FaFacebook />
      </a>
      <a
        href="https://twitter.com/phrubel42"
        className="social-icon"
        target="_blank"
        rel="noreferrer"
      >
        <AiFillTwitterCircle />
      </a>
      <a
        href="https://www.instagram.com/phrubel42/"
        className="social-icon"
        target="_blank"
        rel="noreferrer"
      >
        <AiOutlineInstagram />
      </a>
    </div>
  );
};

export default Social;
